// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tv-map {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: var(--radius-md);
  overflow: hidden;
  background: var(--bg-secondary);
}

.tv-map.compact {
  border-radius: var(--radius-sm);
}

/* Layer selector */
.tv-map-layers {
  display: flex;
  gap: 4px;
  padding: var(--spacing-sm);
  background: var(--bg-primary);
  border-bottom: 1px solid var(--border-color);
  flex-wrap: wrap;
}

.tv-layer-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  color: var(--text-muted);
  font-size: 0.7rem;
  cursor: pointer;
  transition: all var(--transition-fast);
  white-space: nowrap;
}

.tv-layer-btn:hover {
  color: var(--text-primary);
  border-color: var(--accent-cyan);
}

.tv-layer-btn.active {
  background: var(--accent-blue);
  color: white;
  border-color: var(--accent-blue);
}

/* Map container */
.tv-map-container {
  flex: 1 1;
  min-height: 200px;
  position: relative;
}

.tv-windy-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

/* Footer */
.tv-map-footer {
  padding: var(--spacing-xs) var(--spacing-sm);
  background: var(--bg-primary);
  border-top: 1px solid var(--border-color);
}

.tv-map-location {
  font-size: 0.7rem;
  color: var(--text-muted);
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Placeholder */
.tv-map-placeholder {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-sm);
  color: var(--text-muted);
  font-size: 0.8rem;
  opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./src/components/TV/TVMap.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;EACR,0BAA0B;EAC1B,6BAA6B;EAC7B,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,qCAAqC;EACrC,+BAA+B;EAC/B,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA,WAAW;AACX;EACE,4CAA4C;EAC5C,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,gBAAgB;AAChB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,iBAAiB;EACjB,YAAY;AACd","sourcesContent":[".tv-map {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  background: var(--bg-secondary);\n}\n\n.tv-map.compact {\n  border-radius: var(--radius-sm);\n}\n\n/* Layer selector */\n.tv-map-layers {\n  display: flex;\n  gap: 4px;\n  padding: var(--spacing-sm);\n  background: var(--bg-primary);\n  border-bottom: 1px solid var(--border-color);\n  flex-wrap: wrap;\n}\n\n.tv-layer-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  color: var(--text-muted);\n  font-size: 0.7rem;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  white-space: nowrap;\n}\n\n.tv-layer-btn:hover {\n  color: var(--text-primary);\n  border-color: var(--accent-cyan);\n}\n\n.tv-layer-btn.active {\n  background: var(--accent-blue);\n  color: white;\n  border-color: var(--accent-blue);\n}\n\n/* Map container */\n.tv-map-container {\n  flex: 1;\n  min-height: 200px;\n  position: relative;\n}\n\n.tv-windy-iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n/* Footer */\n.tv-map-footer {\n  padding: var(--spacing-xs) var(--spacing-sm);\n  background: var(--bg-primary);\n  border-top: 1px solid var(--border-color);\n}\n\n.tv-map-location {\n  font-size: 0.7rem;\n  color: var(--text-muted);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* Placeholder */\n.tv-map-placeholder {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-sm);\n  color: var(--text-muted);\n  font-size: 0.8rem;\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
